import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { debounce } from 'lodash'
import { scrollToElement } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'
import Pointer from 'components/ui/Pointer/Pointer'

import Dots from './Dots/Dots'

import s from './FullPageScrollSlider.scss'


class FullPageScrollSlider extends Component {

  static propTypes = {
    isMobileDevice: PropTypes.bool, // @injectGlobals
    className: PropTypes.string,
    pointerClassName: PropTypes.string,
    children: PropTypes.node,
    withDots: PropTypes.bool,
    withPointer: PropTypes.bool,
    onPointerClick: PropTypes.func,
  }

  static defaultProps = {
    withDots: true,
    withPointer: true,
  }

  state = {
    activeSlideIndex: 0,
  }

  componentDidMount() {
    this.setSliderInfo()
    this.bindScrollEvent()
  }

  componentDidUpdate() {
    this.setSliderInfo()
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll)
  }

  bindScrollEvent = () => {
    const { isMobileDevice } = this.props

    if (!isMobileDevice) {
      document.addEventListener('scroll', this.handleScroll)
    }
  }

  setSliderInfo = () => {
    if (this.slider) {
      this.slides = this.slider.children
      this.windowVerticalCenter = window.innerHeight / 2
    }
  }

  handleScroll = debounce(() => {
    const { activeSlideIndex } = this.state

    const newSlideIndex = Array.from(this.slides).findIndex((slide) => {
      const bounds = slide.getBoundingClientRect()

      return (
        bounds.top >= 0 && bounds.top < this.windowVerticalCenter
        || bounds.top < 0 && bounds.bottom > this.windowVerticalCenter
      )
    })

    if (newSlideIndex !== activeSlideIndex) {
      this.setState({
        activeSlideIndex: newSlideIndex,
      })

      scrollToElement(this.slides[newSlideIndex], true)
    }
  }, 50)

  setActiveSlide = (index) => {
    const { activeSlideIndex } = this.state
    const { isMobileDevice } = this.props

    if (!isMobileDevice && index !== activeSlideIndex) {
      this.setState({
        activeSlideIndex: index,
      })
    }

    scrollToElement(this.slides[index], true)
  }

  handlePointerClick = (nextIndex) => {
    const { onPointerClick } = this.props

    this.setActiveSlide(nextIndex)

    if (typeof onPointerClick === 'function') {
      onPointerClick(nextIndex)
    }
  }

  render() {
    const { className, children, withDots, withPointer, pointerClassName, isMobileDevice } = this.props
    const { activeSlideIndex } = this.state

    // filter if some of children is falsy. (example NewSubscriptionThankYouPage)
    const slides = React.Children.toArray(children).filter((child) => child)
    const slidesAmount = slides.length
    const isDotsVisible = withDots && !isMobileDevice

    return (
      <Fragment>
        <div className={cx(s.slider, className)} ref={(el) => this.slider = el}>
          {
            slides.map((child, index) => {
              const slideClassName = cx(s.slide, {
                [child.props.className]: child.props.className,
                'activeSlide': index === activeSlideIndex,
              })
              const isPointerVisible = (withPointer && index < slidesAmount - 1)

              return (
                <div className={s.slide} key={`slide${index}`}>
                  {
                    React.cloneElement(child, {
                      className: slideClassName,
                    })
                  }
                  {
                    isPointerVisible && (
                      <Pointer
                        key={`pointer${index}`}
                        className={cx(s.pointer, pointerClassName)}
                        brand
                        onClick={() => this.handlePointerClick(index + 1)}
                      />
                    )
                  }
                </div>
              )
            })
          }
        </div>
        {
          isDotsVisible && (
            <Dots
              amount={slidesAmount}
              activeIndex={activeSlideIndex}
              onClick={this.setActiveSlide}
            />
          )
        }
      </Fragment>
    )
  }
}


export default injectGlobals(({ globals }) => ({
  isMobileDevice: globals.device.isMobile,
}))(FullPageScrollSlider)
